// AUTO GENERATED
// DO NOT MODIFY

const curve = {
  'expressive-standard': {
    desktopValue: 'cubic-bezier(0.4, 0.1, 0.2, 1)',
    desktopDarkValue: 'cubic-bezier(0.4, 0.1, 0.2, 1)',
    iosValue: 'cubic-bezier(0.4, 0.1, 0.2, 1)',
    iosDarkValue: 'cubic-bezier(0.4, 0.1, 0.2, 1)',
    androidValue: 'cubic-bezier(0.4, 0.1, 0.2, 1)',
    androidDarkValue: 'cubic-bezier(0.4, 0.1, 0.2, 1)'
  },
  'expressive-entrance': {
    desktopValue: 'cubic-bezier(0.35, 1.3, 0.25, 1)',
    desktopDarkValue: 'cubic-bezier(0.35, 1.3, 0.25, 1)',
    iosValue: 'cubic-bezier(0.35, 1.3, 0.25, 1)',
    iosDarkValue: 'cubic-bezier(0.35, 1.3, 0.25, 1)',
    androidValue: 'cubic-bezier(0.35, 1.3, 0.25, 1)',
    androidDarkValue: 'cubic-bezier(0.35, 1.3, 0.25, 1)'
  },
  'expressive-exit': {
    desktopValue: 'cubic-bezier(0.4, 0, 1, 1)',
    desktopDarkValue: 'cubic-bezier(0.4, 0, 1, 1)',
    iosValue: 'cubic-bezier(0.4, 0, 1, 1)',
    iosDarkValue: 'cubic-bezier(0.4, 0, 1, 1)',
    androidValue: 'cubic-bezier(0.4, 0, 1, 1)',
    androidDarkValue: 'cubic-bezier(0.4, 0, 1, 1)'
  },
  'productive-standard': {
    desktopValue: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
    desktopDarkValue: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
    iosValue: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
    iosDarkValue: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
    androidValue: 'cubic-bezier(0.2, 0, 0.4, 0.9)',
    androidDarkValue: 'cubic-bezier(0.2, 0, 0.4, 0.9)'
  },
  'productive-entrance': {
    desktopValue: 'cubic-bezier(0, 0, 0.4, 0.9)',
    desktopDarkValue: 'cubic-bezier(0, 0, 0.4, 0.9)',
    iosValue: 'cubic-bezier(0, 0, 0.4, 0.9)',
    iosDarkValue: 'cubic-bezier(0, 0, 0.4, 0.9)',
    androidValue: 'cubic-bezier(0, 0, 0.4, 0.9)',
    androidDarkValue: 'cubic-bezier(0, 0, 0.4, 0.9)'
  },
  'productive-exit': {
    desktopValue: 'cubic-bezier(0.2, 0, 1, 1)',
    desktopDarkValue: 'cubic-bezier(0.2, 0, 1, 1)',
    iosValue: 'cubic-bezier(0.2, 0, 1, 1)',
    iosDarkValue: 'cubic-bezier(0.2, 0, 1, 1)',
    androidValue: 'cubic-bezier(0.2, 0, 1, 1)',
    androidDarkValue: 'cubic-bezier(0.2, 0, 1, 1)'
  }
};
const duration = {
  slowest: {
    desktopValue: '700ms',
    desktopDarkValue: '700ms',
    iosValue: '700ms',
    iosDarkValue: '700ms',
    androidValue: '700ms',
    androidDarkValue: '700ms',
    comment: 'Для модальных окон, затемнения бэкграунда, больших объектов'
  },
  slow: {
    desktopValue: '500ms',
    desktopDarkValue: '500ms',
    iosValue: '500ms',
    iosDarkValue: '500ms',
    androidValue: '500ms',
    androidDarkValue: '500ms',
    comment: 'Для модальных окон, больших объектов'
  },
  moderate: {
    desktopValue: '300ms',
    desktopDarkValue: '300ms',
    iosValue: '300ms',
    iosDarkValue: '300ms',
    androidValue: '300ms',
    androidDarkValue: '300ms',
    comment: 'Для нотификаций, появления компонентов, перемещения объектов'
  },
  fast: {
    desktopValue: '150ms',
    desktopDarkValue: '150ms',
    iosValue: '150ms',
    iosDarkValue: '150ms',
    androidValue: '150ms',
    androidDarkValue: '150ms',
    comment: 'Для микроанимаций, фейдов'
  },
  fastest: {
    desktopValue: '75ms',
    desktopDarkValue: '75ms',
    iosValue: '75ms',
    iosDarkValue: '75ms',
    androidValue: '75ms',
    androidDarkValue: '75ms',
    comment: 'Для микроанимаций, например в тогглах, чекбоксах и т.д.'
  }
};
export const animation = {
  curve,
  duration
};